import {
  Breadcrumb as ChakraBreadcrumb,
  BreadcrumbItem as ChakraBreadcrumbItem,
} from '@chakra-ui/react';
import React from 'react';

import Link from '../Link';
import { Text } from '../Text';
import { BreadcrumbEntry } from './index';

interface BreadcrumbProps {
  entries: BreadcrumbEntry[];
}

interface BreadcrumbContentProps {
  label: string;
  link?: string;
  isLast: boolean;
}

const BreadcrumbContent: React.FC<BreadcrumbContentProps> = ({
  label,
  link,
  isLast,
}) => {
  const color = React.useMemo(
    () => (isLast ? 'gray.1001' : 'wl-blue.royal'),
    [isLast],
  );

  let labelContent = <></>;

  if (isLast) {
    labelContent = <Text color={color}>{label}</Text>;
  } else {
    labelContent = (
      <Text color={color} as="b">
        {label}
      </Text>
    );
  }

  return link ? (
    <Link to={link} color={color} variant="plain">
      {labelContent}
    </Link>
  ) : (
    labelContent
  );
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ entries }) => {
  return (
    <ChakraBreadcrumb separator={<Text color={'red.1001'}>/</Text>}>
      {entries.map((entry, index) => (
        <ChakraBreadcrumbItem
          key={index}
          isCurrentPage={index === entries.length - 1}
        >
          <BreadcrumbContent
            label={entry.label}
            link={entry.link}
            isLast={index === entries.length - 1}
          />
        </ChakraBreadcrumbItem>
      ))}
    </ChakraBreadcrumb>
  );
};

export default Breadcrumb;
